<template>
    <header class="bg-[#18181B]">
        <nav
            class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
            aria-label="Global"
        >
            <div class="flex lg:flex-1">
                <RouterLink to="/" class="-m-1.5 p-1.5">
                    <img class="h-8 w-auto" :src="logoInkor" alt="Inkor" />
                </RouterLink>
            </div>

            <div class="flex lg:hidden">
                <button
                    type="button"
                    class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
                    @click="mobileMenuOpen = true"
                >
                    <Bars3Icon class="size-6" aria-hidden="true" />
                </button>
            </div>

            <PopoverGroup class="hidden lg:flex lg:gap-x-8 lg:items-center">
                <RouterLink
                    to="/sobre-nos"
                    class="text-sm font-semibold text-white"
                    >Sobre Nós</RouterLink
                >

                <router-link
                    class="text-sm font-semibold text-white"
                    :to="{ name: 'blog' }"
                    @click.native="
                        () =>
                            router
                                .replace({ path: '/temp' })
                                .then(() => router.push({ name: 'blog' }))
                    "
                >
                    Blog
                </router-link>

                <!-- Produtos Dropdown -->
                <Popover class="relative">
                    <PopoverButton
                        class="flex items-center gap-x-1 text-sm font-semibold text-white cursor-pointer"
                    >
                        Produtos
                        <ChevronDownIcon
                            class="size-5 flex-none text-gray-400"
                            aria-hidden="true"
                        />
                    </PopoverButton>

                    <transition
                        enter-active-class="transition ease-out duration-200"
                        enter-from-class="opacity-0 translate-y-1"
                        enter-to-class="opacity-100 translate-y-0"
                        leave-active-class="transition ease-in duration-150"
                        leave-from-class="opacity-100 translate-y-0"
                        leave-to-class="opacity-0 translate-y-1"
                    >
                        <PopoverPanel
                            class="absolute -left-8 top-full z-30 mt-3 w-screen max-w-xs overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5"
                        >
                            <div class="p-4">
                                <div
                                    v-for="cat in categorias"
                                    :key="cat.id"
                                    @click="irParaCategoria(cat.slug)"
                                    class="cursor-pointer group relative flex gap-x-6 rounded-lg p-2 text-sm hover:bg-gray-50"
                                >
                                    <div class="flex-auto">
                                        <span
                                            class="block font-semibold text-gray-900"
                                            >{{ cat.nome }}</span
                                        >
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                <a
                  v-for="item in callsToAction"
                  :key="item.name"
                  :href="item.href"
                  class="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold text-gray-900 hover:bg-gray-100"
                >
                  <component :is="item.icon" class="size-5 flex-none text-gray-400" aria-hidden="true" />
                  {{ item.name }}
                </a>
              </div> -->
                        </PopoverPanel>
                    </transition>
                </Popover>

                <a href="/vagas" class="text-sm font-semibold text-white"
                    >Trabalhe Conosco</a
                >
                <a href="/downloads" class="text-sm font-semibold text-white"
                    >Downloads</a
                >

                <!-- Busca em tempo real -->
                <Popover class="relative">
                    <PopoverButton
                        class="flex items-center gap-x-1 text-sm font-semibold text-white cursor-pointer"
                    >
                        <Search />
                    </PopoverButton>

                    <transition
                        enter-active-class="transition ease-out duration-200"
                        enter-from-class="opacity-0 translate-y-1"
                        enter-to-class="opacity-100 translate-y-0"
                        leave-active-class="transition ease-in duration-150"
                        leave-from-class="opacity-100 translate-y-0"
                        leave-to-class="opacity-0 translate-y-1"
                    >
                        <PopoverPanel
                            class="absolute -left-8 top-full z-30 mt-3 w-screen max-w-md overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5"
                        >
                            <div class="p-4">
                                <label
                                    for="busca-produtos"
                                    class="text-md font-semibold block mb-2"
                                >
                                    Pesquisar Produtos
                                </label>
                                <input
                                    id="busca-produtos"
                                    ref="searchInputRef"
                                    v-model="searchQuery"
                                    @keydown="onSearchKeydown"
                                    type="text"
                                    placeholder="Digite o nome do produto..."
                                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-vermelho focus:border-vermelho transition text-gray-900 placeholder-gray-400"
                                    autocomplete="off"
                                    role="combobox"
                                    aria-expanded="true"
                                    aria-controls="resultado-busca"
                                    aria-autocomplete="list"
                                />
                            </div>

                            <!-- Estado: carregando -->
                            <div
                                v-if="isSearching"
                                class="px-4 pb-3 text-sm text-gray-500"
                            >
                                Buscando…
                            </div>

                            <!-- Lista de resultados -->
                            <div
                                v-if="!isSearching && searchQuery"
                                id="resultado-busca"
                                class="max-h-80 overflow-y-auto divide-y"
                            >
                                <button
                                    v-for="(p, i) in searchResults"
                                    :key="p.id || i"
                                    @click="abrirProduto(p)"
                                    :class="[
                                        'w-full text-left px-4 py-2 flex gap-3 items-center hover:bg-gray-50 focus:bg-gray-50 border-b border-gray-200 cursor-pointer',
                                    ]"
                                    role="option"
                                    :aria-selected="i === highlightedIndex"
                                >
                                    <img
                                        v-if="p.thumb || p.imagem"
                                        :src="p.thumb || p.imagem"
                                        class="h-10 w-10 object-cover rounded"
                                        :alt="p.nome || 'Produto'"
                                    />
                                    <div class="min-w-0">
                                        <div
                                            class="truncate font-medium text-gray-900"
                                        >
                                            {{ p.nome || p.title }}
                                        </div>
                                        <div
                                            v-if="p.categoria"
                                            class="text-xs text-gray-500 truncate"
                                        >
                                            {{ p.categoria }}
                                        </div>
                                    </div>
                                </button>

                                <div
                                    v-if="searchResults.length === 0"
                                    class="px-4 py-3 text-sm text-gray-500"
                                >
                                    Nenhum produto encontrado.
                                </div>
                            </div>

                            <!-- Erro -->
                            <div
                                v-if="searchError"
                                class="px-4 py-3 text-sm text-red-600"
                            >
                                {{ searchError }}
                            </div>

                            <!-- Rodapé: ver todos -->
                            <div
                                v-if="searchQuery.trim()"
                                class="p-3 bg-gray-50"
                            >
                                <RouterLink
                                    :to="{
                                        path: '/todos-produtos',
                                        query: { q: searchQuery },
                                    }"
                                    class="block text-center text-sm font-semibold text-gray-900 hover:underline"
                                    @click="
                                        searchQuery = '';
                                        limparBusca();
                                    "
                                >
                                    Ver todos os resultados
                                </RouterLink>
                            </div>
                        </PopoverPanel>
                    </transition>
                </Popover>

                <a
                    href="/contato"
                    class="text-sm bg-vermelho hover:bg-vermelho text-white gap-1 px-4 py-1.5 rounded-lg font-semibold"
                >
                    Entre em Contato
                </a>
            </PopoverGroup>
        </nav>

        <!-- Mobile Menu -->
        <Dialog
            class="lg:hidden"
            @close="mobileMenuOpen = false"
            :open="mobileMenuOpen"
        >
            <div class="fixed inset-0 z-10" />
            <DialogPanel
                class="fixed inset-y-0 right-0 z-10 w-full flex flex-col justify-between overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
            >
                <div class="p-6">
                    <div class="flex items-center justify-between">
                        <RouterLink
                            to="/"
                            class="flex items-center gap-2 rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                        >
                            <HouseIcon class="h-4 w-4" />
                            Início
                        </RouterLink>
                        <button
                            type="button"
                            class="-m-2.5 rounded-md p-2.5 text-gray-700"
                            @click="mobileMenuOpen = false"
                        >
                            <XMarkIcon class="size-6" aria-hidden="true" />
                        </button>
                    </div>

                    <div class="mt-6 flow-root">
                        <div class="-my-6 divide-y divide-gray-500/10">
                            <!-- Busca Mobile -->
                            <div class="py-6">
                                <div class="mb-4">
                                    <label
                                        for="busca-mobile"
                                        class="text-lg font-semibold block mb-2 text-gray-900"
                                    >
                                        Pesquisar Produtos
                                    </label>
                                    <div class="relative">
                                        <div
                                            class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                                        >
                                            <Search
                                                class="h-5 w-5 text-gray-400"
                                            />
                                        </div>
                                        <input
                                            id="busca-mobile"
                                            ref="searchMobileInputRef"
                                            v-model="searchQueryMobile"
                                            @keydown="onSearchMobileKeydown"
                                            type="text"
                                            placeholder="Digite o nome do produto..."
                                            class="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-vermelho focus:border-vermelho transition text-gray-900 placeholder-gray-400"
                                            autocomplete="off"
                                            role="combobox"
                                            aria-expanded="true"
                                            aria-controls="resultado-busca-mobile"
                                            aria-autocomplete="list"
                                        />
                                    </div>
                                </div>

                                <!-- Estado: carregando mobile -->
                                <div
                                    v-if="isSearchingMobile"
                                    class="text-sm text-gray-500 mb-3"
                                >
                                    Buscando…
                                </div>

                                <!-- Lista de resultados mobile -->
                                <div
                                    v-if="
                                        !isSearchingMobile && searchQueryMobile
                                    "
                                    id="resultado-busca-mobile"
                                    class="max-h-64 overflow-y-auto space-y-2 mb-4"
                                >
                                    <button
                                        v-for="(p, i) in searchResultsMobile"
                                        :key="p.id || i"
                                        @click="abrirProdutoMobile(p)"
                                        :class="[
                                            'w-full text-left p-3 flex gap-3 items-center hover:bg-gray-50 focus:bg-gray-50 rounded-lg border border-gray-200',
                                        ]"
                                        role="option"
                                        :aria-selected="
                                            i === highlightedIndexMobile
                                        "
                                    >
                                        <img
                                            v-if="p.thumb || p.imagem"
                                            :src="p.thumb || p.imagem"
                                            class="h-12 w-12 object-cover rounded"
                                            :alt="p.nome || 'Produto'"
                                        />
                                        <div class="min-w-0 flex-1">
                                            <div
                                                class="font-medium text-gray-900 truncate"
                                            >
                                                {{ p.nome || p.title }}
                                            </div>
                                            <div
                                                v-if="p.categoria"
                                                class="text-sm text-gray-500 truncate"
                                            >
                                                {{ p.categoria }}
                                            </div>
                                        </div>
                                    </button>

                                    <div
                                        v-if="searchResultsMobile.length === 0"
                                        class="text-sm text-gray-500 p-3 text-center border border-gray-200 rounded-lg"
                                    >
                                        Nenhum produto encontrado.
                                    </div>
                                </div>

                                <!-- Ver todos os resultados mobile -->
                                <div
                                    v-if="searchQueryMobile.trim()"
                                    class="mb-4"
                                >
                                    <RouterLink
                                        :to="{
                                            path: '/todos-produtos',
                                            query: { q: searchQueryMobile },
                                        }"
                                        @click="
                                            mobileMenuOpen = false;
                                            searchQueryMobile = '';
                                            limparBuscaMobile();
                                        "
                                        class="block w-full text-center py-3 px-4 bg-vermelho text-white rounded-lg font-semibold hover:bg-red-600 transition-colors"
                                    >
                                        Ver todos os resultados
                                    </RouterLink>
                                </div>

                                <!-- Erro mobile -->
                                <div
                                    v-if="searchErrorMobile"
                                    class="text-sm text-red-600 p-3 bg-red-50 rounded-lg mb-4"
                                >
                                    {{ searchErrorMobile }}
                                </div>
                            </div>

                            <div class="space-y-2 py-6">
                                <RouterLink
                                    to="/sobre-nos"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Sobre Nós
                                </RouterLink>
                                <hr class="text-gray-300" />
                                <div
                                    v-for="cat in categorias"
                                    :key="cat.id"
                                    @click="handleMobileRedirect(cat.slug)"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50 cursor-pointer"
                                >
                                    {{ cat.nome }}
                                </div>
                                <hr class="text-gray-300" />
                                <a
                                    href="/blog"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    >Blog</a
                                >
                                <a
                                    href="/contato"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    >Entre em Contato</a
                                >
                                <a
                                    href="/vagas"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    >Trabalhe Conosco</a
                                >
                                <a
                                    href="/downloads"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                                    >Downloads</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </DialogPanel>
        </Dialog>
    </header>
</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount, nextTick } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import logoInkor from "../assets/img/inkor-logo.png";

import {
    Dialog,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from "@headlessui/vue";
import {
    ChevronDownIcon,
    PhoneIcon,
    PlayCircleIcon,
} from "@heroicons/vue/20/solid";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import { Headset, HouseIcon, Search } from "lucide-vue-next";

const router = useRouter();
const categorias = ref([]);
const mobileMenuOpen = ref(false);

// Opcional: se quiser mostrar botões no dropdown de Produtos
const callsToAction = [
    { name: "Institucional", href: "#", icon: PlayCircleIcon },
    { name: "Entre em Contato", href: "/contato", icon: PhoneIcon },
];

const irParaCategoria = (slug) => {
    router.push({
        name: "produtos-categoria",
        params: { categoriaSlug: slug },
    });
};

const handleMobileRedirect = (slug) => {
    mobileMenuOpen.value = false;
    irParaCategoria(slug);
};

onMounted(async () => {
    const { data } = await axios.get("/api/categorias");
    categorias.value = data;
});

/* =========================
   BUSCA EM TEMPO REAL
   ========================= */
const searchQuery = ref("");
const searchResults = ref([]);
const isSearching = ref(false);
const searchError = ref("");
const highlightedIndex = ref(-1);
const searchInputRef = ref(null);

// Busca Mobile
const searchQueryMobile = ref("");
const searchResultsMobile = ref([]);
const isSearchingMobile = ref(false);
const searchErrorMobile = ref("");
const highlightedIndexMobile = ref(-1);
const searchMobileInputRef = ref(null);

let debounceTimer;
let abortController = null;
let debounceTimerMobile;
let abortControllerMobile = null;

const limparBusca = () => {
    searchResults.value = [];
    highlightedIndex.value = -1;
    searchError.value = "";
};

const limparBuscaMobile = () => {
    searchResultsMobile.value = [];
    highlightedIndexMobile.value = -1;
    searchErrorMobile.value = "";
};

const fetchProdutos = async () => {
    const q = (searchQuery.value || "").trim();
    if (!q) {
        limparBusca();
        return;
    }

    // Cancela requisição anterior ainda em voo
    if (abortController) abortController.abort();
    abortController = new AbortController();

    isSearching.value = true;
    searchError.value = "";

    try {
        const { data } = await axios.get("/api/produtos/search", {
            params: { q, limit: 8 },
            signal: abortController.signal, // axios >= 1.2
        });

        // Suporta array direto ou objetos {items|results}
        const items = Array.isArray(data)
            ? data
            : data.items || data.results || [];
        searchResults.value = items;
        highlightedIndex.value = items.length ? 0 : -1;
    } catch (err) {
        // Ignora erro se foi cancelado
        if (err && err.name === "CanceledError") return;
        if (err && err.code === "ERR_CANCELED") return;
        searchError.value =
            "Não foi possível buscar os produtos. Tente novamente.";
    } finally {
        isSearching.value = false;
    }
};

const fetchProdutosMobile = async () => {
    const q = (searchQueryMobile.value || "").trim();
    if (!q) {
        limparBuscaMobile();
        return;
    }

    // Cancela requisição anterior ainda em voo
    if (abortControllerMobile) abortControllerMobile.abort();
    abortControllerMobile = new AbortController();

    isSearchingMobile.value = true;
    searchErrorMobile.value = "";

    try {
        const { data } = await axios.get("/api/produtos/search", {
            params: { q, limit: 8 },
            signal: abortControllerMobile.signal,
        });

        // Suporta array direto ou objetos {items|results}
        const items = Array.isArray(data)
            ? data
            : data.items || data.results || [];
        searchResultsMobile.value = items;
        highlightedIndexMobile.value = items.length ? 0 : -1;
    } catch (err) {
        // Ignora erro se foi cancelado
        if (err && err.name === "CanceledError") return;
        if (err && err.code === "ERR_CANCELED") return;
        searchErrorMobile.value =
            "Não foi possível buscar os produtos. Tente novamente.";
    } finally {
        isSearchingMobile.value = false;
    }
};

// Dispara a busca com debounce (300ms)
watch(searchQuery, () => {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(fetchProdutos, 300);
});

// Dispara a busca mobile com debounce (300ms)
watch(searchQueryMobile, () => {
    if (debounceTimerMobile) window.clearTimeout(debounceTimerMobile);
    debounceTimerMobile = window.setTimeout(fetchProdutosMobile, 300);
});

const abrirProduto = (produto) => {
    // Fecha o popover
    searchQuery.value = "";
    limparBusca();

    // Navega para o produto
    if (produto && produto.slug) {
        router.push({ name: "produto", params: { slug: produto.slug } });
    } else {
        // Fallback: envia para página de todos os produtos com a query atual
        router.push({
            path: "/todos-produtos",
            query: { q: produto?.nome || searchQuery.value },
        });
    }
};

const abrirProdutoMobile = (produto) => {
    // Fecha o menu mobile
    searchQueryMobile.value = "";
    limparBuscaMobile();
    mobileMenuOpen.value = false;

    // Navega para o produto
    if (produto && produto.slug) {
        router.push({ name: "produto", params: { slug: produto.slug } });
    } else {
        // Fallback: envia para página de todos os produtos com a query atual
        router.push({
            path: "/todos-produtos",
            query: { q: produto?.nome || searchQueryMobile.value },
        });
    }
};

const onSearchKeydown = (e) => {
    const total = searchResults.value.length;

    if (e.key === "ArrowDown" && total) {
        e.preventDefault();
        highlightedIndex.value = (highlightedIndex.value + 1) % total;
    } else if (e.key === "ArrowUp" && total) {
        e.preventDefault();
        highlightedIndex.value = (highlightedIndex.value - 1 + total) % total;
    } else if (e.key === "Enter") {
        if (highlightedIndex.value >= 0 && highlightedIndex.value < total) {
            e.preventDefault();
            abrirProduto(searchResults.value[highlightedIndex.value]);
        } else if ((searchQuery.value || "").trim()) {
            router.push({
                path: "/todos-produtos",
                query: { q: searchQuery.value },
            });
        }
    } else if (e.key === "Escape") {
        searchQuery.value = "";
        limparBusca();
        nextTick(() => searchInputRef.value && searchInputRef.value.blur());
    }
};

const onSearchMobileKeydown = (e) => {
    const total = searchResultsMobile.value.length;

    if (e.key === "ArrowDown" && total) {
        e.preventDefault();
        highlightedIndexMobile.value =
            (highlightedIndexMobile.value + 1) % total;
    } else if (e.key === "ArrowUp" && total) {
        e.preventDefault();
        highlightedIndexMobile.value =
            (highlightedIndexMobile.value - 1 + total) % total;
    } else if (e.key === "Enter") {
        if (
            highlightedIndexMobile.value >= 0 &&
            highlightedIndexMobile.value < total
        ) {
            e.preventDefault();
            abrirProdutoMobile(
                searchResultsMobile.value[highlightedIndexMobile.value],
            );
        } else if ((searchQueryMobile.value || "").trim()) {
            mobileMenuOpen.value = false;
            router.push({
                path: "/todos-produtos",
                query: { q: searchQueryMobile.value },
            });
        }
    } else if (e.key === "Escape") {
        searchQueryMobile.value = "";
        limparBuscaMobile();
        nextTick(
            () =>
                searchMobileInputRef.value && searchMobileInputRef.value.blur(),
        );
    }
};

onBeforeUnmount(() => {
    if (abortController) abortController.abort();
    if (abortControllerMobile) abortControllerMobile.abort();
    if (debounceTimer) window.clearTimeout(debounceTimer);
    if (debounceTimerMobile) window.clearTimeout(debounceTimerMobile);
});
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
